import React, { useState, useEffect } from "react";
import Footer from "./footer";
import DashboardNavbar from "./DashboardNavbar";
import "../style.css";
import { getData } from "../api/protectedApi";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";


const MyTeam = () => {
  const [teamData, setTeamData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const perPage = 10;

  const getTeamList = async (page = 0) => {
    try {
      const res = await getData(
        `/self_level_view?per_page=${perPage}&page=${page + 1}`
      );

      setTeamData(res.data.data || []);
      setTotalPages(Number(res.data.pagination.total_pages || 0));
      setCurrentPage(page);
    } catch (err) {
      console.error("Error fetching team list:", err);
    }
  };

  useEffect(() => {
    getTeamList(0);
  }, []);

  const handlePageClick = (event) => {
    getTeamList(event.selected);
  };

  return (
    <div
      style={{
        backgroundColor: "#0d0e13",
        minHeight: "100vh",
        color: "#fff",
        padding: "12px 0",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* NAVBAR */}
      <DashboardNavbar />

      <section>
        <div className="container">
          <div className="directs-wrapper">
            <div className="directs-title">My Team List</div>

            <div className="table-responsive">
              <table className="table directs-table align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Level</th>
                    <th>Team</th>
                    <th>Team Business</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {teamData.length > 0 ? (
                    teamData.map((item, index) => (
                      <tr key={index}>
                        <td>{currentPage * perPage + index + 1}</td>
                        <td>Level {item.level}</td>
                        <td>{item.total_team}</td>
                        <td>{item.team_business}</td>
                        <td>
                          <Link
                            to={`/level_team/${item.level}`}
                            className="btn btn-sm view2-btn"
                          >
                            View
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* PAGINATION */}
            {totalPages > 1 && (
              <ReactPaginate
                previousLabel={<FaChevronLeft />}
                nextLabel={<FaChevronRight />}
                pageCount={totalPages}
                onPageChange={handlePageClick}
                containerClassName="pagination custom-pagination justify-content-center mt-4"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                nextClassName="page-item"
                previousLinkClassName="page-link"
                nextLinkClassName="page-link"
                activeClassName="active"
              />

            )}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <Footer />
    </div>
  );
};

export default MyTeam;
